var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group_products" },
    [
      _c("div", { staticClass: "head_group_products" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-md btn-block btn-outline-success waves-effect waves-themed",
            on: { click: _vm.select_product },
          },
          [
            _c("span", { staticClass: "fal fa-eject mr-1" }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.__t("SELECT_PRODUCT")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "products_list" }, [
        _vm.selected_items.length > 0
          ? _c(
              "div",
              { staticClass: "products" },
              [
                _c("product_inside_list", {
                  key: "prod_list_in_group",
                  attrs: {
                    show_select: false,
                    show_remove: true,
                    items: _vm.selected_items,
                  },
                  on: { remove_product: _vm.remove_item },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.show_product_search
        ? _c("product_search_list", {
            attrs: { exclude_ids: _vm.exclude_prod_ids },
            on: {
              finish_select: _vm.on_finish_select_products,
              close_product_search: _vm.close_select_product,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }